<template>
  <page-header-wrapper>
    <a-card :bordered="false">
      <div class="table-operations">
        <a-button type="primary" @click="$refs.createForm.handleAdd()" v-hasPermi="['land:areaPrice:add']"><a-icon type="plus" />新增</a-button>
        <a-button type="danger" :disabled="multiple" @click="handleDelete" v-hasPermi="['land:areaPrice:remove']"><a-icon type="delete" />删除</a-button>
      </div>
      <create-form ref="createForm" @ok="getList" />
      <a-table :loading="loading" rowKey="id" :columns="columns" :data-source="list"
        :row-selection="{ selectedRowKeys: selectedRowKeys, onChange: onSelectChange }" :pagination="false" :bordered="tableBordered">
        <span slot="status" slot-scope="text, record">
          <a-switch :checked="record.status === 1" @change="(checked) => handleStatusChange(record, checked)" />
        </span>
        <span slot="operation" slot-scope="text, record">
          <a @click="$refs.createForm.handleUpdate(record)" v-hasPermi="['land:areaPrice:edit']"><a-icon type="edit" />修改</a>
          <a-divider type="vertical" />
          <a @click="handleDelete(record)" v-hasPermi="['land:areaPrice:remove']"><a-icon type="delete" />删除</a>
        </span>
      </a-table>
    </a-card>
  </page-header-wrapper>
</template>

<script>
import { pageAreaPrice, delAreaPrice, updateAreaPrice } from '@/api/cloudplant/areaPrice'
import { tableMixin } from '@/store/table-mixin'
import CreateForm from './modules/CreateForm'

export default {
  name: 'LandAreaPrice',
  mixins: [tableMixin],
  components: { CreateForm },
  data() {
    return {
      list: [], loading: false, selectedRowKeys: [], multiple: true,
      queryParam: { pageNum: 1, pageSize: 100 },
      columns: [
        { title: '面积(㎡)', dataIndex: 'area', align: 'center' },
        { title: '价格(元)', dataIndex: 'price', align: 'center' },
        { title: '排序', dataIndex: 'sort', align: 'center', width: 80 },
        { title: '平台赠送', dataIndex: 'isPlatformGift', align: 'center', width: 100,
          customRender: (text) => text === 1 ? '是' : '否' },
        { title: '状态', dataIndex: 'status', scopedSlots: { customRender: 'status' }, align: 'center', width: 100 },
        { title: '操作', dataIndex: 'operation', scopedSlots: { customRender: 'operation' }, align: 'center', width: 150 }
      ]
    }
  },
  created() { this.getList() },
  methods: {
    getList() {
      this.loading = true
      pageAreaPrice(this.queryParam).then(response => { this.list = response.data.records; this.loading = false })
    },
    onSelectChange(selectedRowKeys) { this.selectedRowKeys = selectedRowKeys; this.multiple = !selectedRowKeys.length },
    handleStatusChange(record, checked) {
      const status = checked ? 1 : 0
      updateAreaPrice({ id: record.id, status: status }).then(() => { this.$message.success('修改成功'); this.getList() })
    },
    handleDelete(row) {
      const that = this
      const ids = row.id || this.selectedRowKeys
      this.$confirm({
        title: '确认删除所选中数据?',
        onOk() {
          let data = []
          if (row.id) { data.push(row.id) } else { that.selectedRowKeys.forEach(id => data.push(id)) }
          return delAreaPrice(data).then(() => { that.onSelectChange([]); that.getList(); that.$message.success('删除成功', 3) })
        }
      })
    }
  }
}
</script>
